const Loading = () =>{

  return (
    <div className="App">
      <header className="App-header">
        <img src="loading.png" className="App-logo" alt="logo" />
      </header>
    </div>
  );
}

export default Loading;
